import { type CustomFieldColor } from '@air/api/types';
import { type Color } from '@air/primitive-color-picker';

export const mapCustomFieldColorToPickerColor = (color: CustomFieldColor): Color => ({
  id: color.id,
  name: color.name,
  hex: color.backgroundHex,
});
